import React from "react";
import { Link } from "gatsby";
import "components/Project-detail-shared/project-detail-shared.scss";
import "./project-client-testimonial.scss";
import { StaticImage } from "gatsby-plugin-image";

const ProjectClientTestimonial = () => {
  return (
    <section className="pd-section section-padding pd-testimonial-cta">
      <div className="container">
        <div className="section-head mb-40">
          <h2 className="pb-2">What Our Client Says</h2>
        </div>
        
        <div className="pd-testimonial-block wow fadeInUp">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="pd-quote-wrapper">
                <i className="fas fa-quote-left pd-quote-icon"></i>
                <p className="pd-quote-text">
                  "The Alloggiati integration by Evolvan has been a game-changer for our operations. What used to take hours daily is now completely automated. We are 100% compliant, and our managers love the peace of mind."
                </p>
                <div className="pd-client-meta mt-4">
                  <div className="pd-client-img">
                    <img src="/img/team/1.jpg" alt="Client" />
                  </div>
                  <div className="pd-client-info">
                    <h6>Aimantis Product Team</h6>
                    <span>Product Management</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="pd-client-stats-grid">
                <div className="pd-client-stat">
                  <h3>1,200+</h3>
                  <p>Properties Using</p>
                </div>
                <div className="pd-client-stat">
                  <h3>50K+</h3>
                  <p>Guests Reported Monthly</p>
                </div>
                <div className="pd-client-stat">
                  <h3>100%</h3>
                  <p>Client Satisfaction</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pd-cta-banner wow fadeInUp" data-wow-delay="0.2s">
          <div className="row align-items-center">
            <div className="col-12 text-center">
              <h3>Ready to Build Your Next Success Story?</h3>
              <p>Let's discuss how we can solve complex challenges and drive real business impact for your product.</p>
              <Link to="/contact" className="butn bord curve mt-30">
                <span>Start a Project <i className="fas fa-arrow-right ml-10"></i></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectClientTestimonial;
